// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumb-size {
  width: 50px;
  height: 50px;
}

.right {
  text-align: right;
}

.order-create-stepper ::ng-deep .mat-horizontal-stepper-header-container {
  padding-bottom: 0;
  margin-bottom: 0 !important;
}
.order-create-stepper ::ng-deep .mat-horizontal-stepper-header {
  height: 40px !important;
}

@media (min-width: 992px) {
  .mat-column-price,
  .mat-column-amount,
  .mat-column-total {
    max-width: 200px;
  }
}
@media (max-width: 991px) {
  mat-footer-cell:first-of-type {
    padding-left: 0;
  }
}
.alternate-footer-row {
  height: 48px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/order/components/order-create/order-create.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAGC;EACC,iBAAA;EACA,2BAAA;AAAF;AAGC;EACC,uBAAA;AADF;;AAKA;EAEC;;;IAGC,gBAAA;EAHA;AACF;AAOA;EACC;IACC,eAAA;EALA;AACF;AAQA;EACC,YAAA;EACA,mBAAA;AAND","sourcesContent":[".thumb-size {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n}\r\n\r\n.right {\r\n\ttext-align: right\r\n}\r\n\r\n.order-create-stepper {\r\n\t::ng-deep .mat-horizontal-stepper-header-container {\r\n\t\tpadding-bottom: 0;\r\n\t\tmargin-bottom: 0 !important;\r\n\t}\r\n\r\n\t::ng-deep .mat-horizontal-stepper-header {\r\n\t\theight: 40px !important;\r\n\t}\r\n}\r\n\r\n@media(min-width: 992px) {\r\n\r\n\t.mat-column-price,\r\n\t.mat-column-amount,\r\n\t.mat-column-total {\r\n\t\tmax-width: 200px;\r\n\t\t;\r\n\t}\r\n}\r\n\r\n@media(max-width: 991px) {\r\n\tmat-footer-cell:first-of-type {\r\n\t\tpadding-left: 0;\r\n\t}\r\n}\r\n\r\n.alternate-footer-row {\r\n\theight: 48px;\r\n\talign-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
